import { Link } from 'react-router-dom';

import { MenuProps } from 'antd';

import CatalogIcon from 'assets/images/menu/catalog.svg?react';
import DashboardIcon from 'assets/images/menu/dashboard.svg?react';
import DocumentsIcon from 'assets/images/menu/documents.svg?react';
import WalletIcon from 'assets/images/menu/earnings.svg?react';
import LegalInfoIcon from 'assets/images/menu/legal-info.svg?react';
import OffersIcon from 'assets/images/menu/offers.svg?react';
import ReportsIcon from 'assets/images/menu/reports.svg?react';
import HelpIcon from 'assets/images/menu/support.svg?react';
import UsersIcon from 'assets/images/menu/users.svg?react';
import { i18n } from 'i18n';
import { EMainRoutes } from 'shared/typings';

type MenuItem = Required<MenuProps>['items'][number];

// const handleLinkClick = (gaEventName: EGaEvents) => {
// 	const pathName = location.pathname.replace(/^\//, '');
// 	sendGaEvent(gaEventName, {
// 		event_option1: `${EGaCategories.ACCOUNT};${pathName || EGaTypes.DASHBOARD}`,
// 		event_option2: EGaTypes.SIDE_MENU,
// 	});
// };

export const MENU_ITEMS_ADV: MenuItem[] = [
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.DASHBOARD}`}>{i18n.t('Dashboard')}</Link>,
		key: EMainRoutes.DASHBOARD,
		icon: <DashboardIcon />,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_DASHBOARD),
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.OFFERS}`}>{i18n.t('Offers')}</Link>,
		key: EMainRoutes.OFFERS,
		icon: <OffersIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.CONTRACTORS}`}>{i18n.t('Contractors')}</Link>,
		key: EMainRoutes.CONTRACTORS,
		icon: <UsersIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.BALANCE}`}>{i18n.t('Balance')}</Link>,
		key: EMainRoutes.BALANCE,
		icon: <WalletIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.LEGAL_INFO}`}>{i18n.t('Legal info')}</Link>,
		key: EMainRoutes.LEGAL_INFO,
		icon: <LegalInfoIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.REPORTS}`}>{i18n.t('Reports')}</Link>,
		key: EMainRoutes.REPORTS,
		icon: <ReportsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.ADVERTISER}/${EMainRoutes.DOCUMENTS}`}>{i18n.t('Documents')}</Link>,
		key: EMainRoutes.DOCUMENTS,
		icon: <DocumentsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.CATALOG}`}>{i18n.t('Service catalog')}</Link>,
		key: EMainRoutes.CATALOG,
		icon: <CatalogIcon />,
		disabled: true,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_CATALOG),
	},
	{
		type: 'divider',
	},
	{
		key: `menuItem_key_Help`,
		icon: <HelpIcon />,
		label: <span>{i18n.t('Help center')}</span>,
		// onClick: () => handleLinkClick(EGaEvents.CLICK_HELP_CENTER),
	},
];
